
















































import { ValidationObserver } from "vee-validate";
import { Component, PropSync, Prop, VModel, Mixins, Emit, Ref } from 'vue-property-decorator';

import ModelSetter from "../../../Mixins/ModelSetter";
import SelectInput from "../../Pi/fields/SelectInput/SelectInput.vue";
import { SelectOptionData } from "../../Pi/types";
import TypedChipsSettingMixin from "../TypedChipsSettingMixin";
import {
  ModalAction,
  PossibleChipTypeInfo,
  RawChipItem,
  RawFrontendChipItem
} from "../typedChips.types";

@Component({
  components: {
    ValidationObserver,
    SelectInput
  }
})
export default class ChipSettingModal extends Mixins(ModelSetter) {
  @VModel({ required: true, default: null }) newCurrent!: RawFrontendChipItem | null

  @PropSync('isModalOpen', { type: Boolean, default: false }) modal!: boolean

  @Prop() modalAction!: ModalAction

  @Prop({ type: Object, required: true }) possibleChipTypeInfos!: PossibleChipTypeInfo

  @Ref('settingComponent') settingComp!: TypedChipsSettingMixin

  @Prop() prefix!: string

  @Emit()
  addChip(chipsToAdd: RawFrontendChipItem) {
    return chipsToAdd
  }

  onOkClick() {
    if(this.settingComp.processChipsValues) {
      this.settingComp.processChipsValues()
    }
  }

  onChips(chips: RawChipItem) {
    if (this.newCurrent) {
      this.newCurrent.model = chips

      this.addChip(this.newCurrent)
    }
  }

  get modalTitle() {
    return this.modalAction === 'new'
      ? this.$t('typed_chips_modal_new_item_title').toString()
      : this.$t('typed_chips_modal_edit_item_title').toString()
  }

  get modalOkButtonTitle() {
    return this.modalAction === 'new'
      ? this.$t('typed_chips_modal_ok_button_add_title').toString()
      : this.$t('typed_chips_modal_ok_button_save_title').toString()
  }

  onTypeChange(option: SelectOptionData) {
    if (this.newCurrent) {
      this.newCurrent.info = this.possibleChipTypeInfos[option.value]
      this.newCurrent.type = option.value
    }
  }

  get typeOptions(): Array<SelectOptionData> {
    return Object.entries(this.possibleChipTypeInfos).map(([ key, value ]) => {
      return {
        label: value.label,
        value: key
      }
    })
  }

}
